import axios, {AxiosError} from 'axios';
import Swal from 'sweetalert2';
import {ResponseList} from "../../../models/Response";
import {useEffect, useState} from "react";


type EmailConfigModel = {
    sid: string
    wftype: string
    wfcondition: string
    contentsubject: string
    contentbody: string
    emailcc: string
    emailbcc: string
}

function EmailConfigViewModel() {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [emailConfigs, setEmailConfigs] = useState<EmailConfigModel[]>()

    useEffect(() => {
        fetchEmailConfig()
    }, []);
    const fetchEmailConfig = async () => {
        setIsLoading(true);
        const element = document.getElementsByClassName('Loader__background');

        try {
            if (element.length > 0) {
                element[0].className = 'Loader__background show';
            }
            const response = await axios.get<ResponseList<EmailConfigModel>>('/v1/email-config', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        'WF_APPLICATION'
                    )}`
                }
            });

            // console.log(response.data.result_list);

            if (element.length > 0) {
                element[0].className = 'Loader__background hide';
                setEmailConfigs(response.data.result_list)
            }
        } catch (error) {
            if (!error) return;

            if (error instanceof AxiosError) {
                Swal.fire(
                    'Error',
                    error.response?.data.message || 'ไม่ทราบสาเหตุ'
                );
            } else if (error instanceof Error) {
                Swal.fire('Error', error.message);
            }
        } finally {
            if (element.length > 0) {
                setIsLoading(false);
                element[0].className = 'Loader__background hide';
            }
        }
    };

    return {
        isLoading,
        emailConfigs
    };
}

export default EmailConfigViewModel;
